import { RestClient } from '@/api/rest-client'
import { ScheduledDashboardExport } from '@/api/model/scheduled-dashboard-export'
import { cloneDeep } from 'lodash'
import { User } from '../model/user'

export class ScheduledDashboardExportClient extends RestClient<ScheduledDashboardExport> {
    collectionName = 'scheduled_dashboard_exports'
    parseData = ScheduledDashboardExport.fromData

    async create(scheduledDashboardExport: ScheduledDashboardExport): Promise<ScheduledDashboardExport> {
        const request = cloneDeep<any>(scheduledDashboardExport)

        if (scheduledDashboardExport.user instanceof User) {
            request.user = scheduledDashboardExport.user.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: any): Promise<ScheduledDashboardExport> {
        const request = cloneDeep<any>(data)

        if (data.user instanceof User) {
            request.user = data.user.resourceIdentifier
        }

        return super.update(id, request)
    }
}
